// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewTracking-viewTrackingMapContainer-ytURC {
    position: relative;
    width: 100%;
    height: 590px;
}

.ViewTracking-viewTrackProviderDetailsBox-i5zsx {
    position: absolute;
    top: 18px;
    right: 18px;
}

@media (max-width: 767px) {
    .ViewTracking-viewTrackingMapContainer-ytURC {
        height: 365px;
    }
}

@media (max-width: 575px) {
    .ViewTracking-viewTrackProviderDetailsBox-i5zsx {
        top: 6px;
        right: 6px;
        left: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/tracking/ViewTracking.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAGA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,SAAS;IACb;AACJ","sourcesContent":[".viewTrackingMapContainer {\n    position: relative;\n    width: 100%;\n    height: 590px;\n}\n\n.viewTrackProviderDetailsBox {\n    position: absolute;\n    top: 18px;\n    right: 18px;\n}\n\n\n@media (max-width: 767px) {\n    .viewTrackingMapContainer {\n        height: 365px;\n    }\n}\n\n@media (max-width: 575px) {\n    .viewTrackProviderDetailsBox {\n        top: 6px;\n        right: 6px;\n        left: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewTrackingMapContainer": `ViewTracking-viewTrackingMapContainer-ytURC`,
	"viewTrackProviderDetailsBox": `ViewTracking-viewTrackProviderDetailsBox-i5zsx`
};
module.exports = ___CSS_LOADER_EXPORT___;
